export const imagesServices = {
  "second_oeuvres": {
    "id": "second_oeuvres",
    "cover": "",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-10.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-12.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-12.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-12.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-13.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-13.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-13.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-13.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-14.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-14.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-14.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-14.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-17.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-17.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-17.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-17.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-18.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-18.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-18.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-18.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-29.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-29.webp",
      "https://cv-api-omega.vercel.app/bat/pr2/pr2-29.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2/pr2-29.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-3-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-3-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-4.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-4.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-4.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-4.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5-1.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5-1.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-5-1.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-5-1.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-9.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-10.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-10.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A/pr2A-10.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A/pr2A-10.jpg"
    ]
  },
  "gros_oeuvres": {
    "id": "gros_oeuvres",
    "cover": "https://cv-api-omega.vercel.app/bat/pr3/pr3-1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-2.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-2.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-2.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-2.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-9.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-9.webp",
      "https://cv-api-omega.vercel.app/bat/pr3/pr3-9.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr3/pr3-9.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-1.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-1.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-1.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-1.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-2.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-2.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-2.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-2.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-5.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-5.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-5.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-5.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-6.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-6.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-6.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-6.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-3.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-3.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-3.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-3.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-4.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-4.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-4.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-4.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-7.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-7.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-7.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-7.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-8.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-8.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-8.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-8.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-9.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-9.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-9.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-9.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-10.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-10.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-10.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-10.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-11.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-11.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-11.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-11.jpg",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-12.webp",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-12.webp",
      "https://cv-api-omega.vercel.app/serv/pr1/pr1-12.jpg",
      "https://boogysh.github.io/cv-api/images/serv/pr1/pr1-12.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-25.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-25.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-25.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-25.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-26.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-26.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-26.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-26.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-6.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-6.webp",
      "https://cv-api-omega.vercel.app/bat/pr6/pr6-6.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr6/pr6-6.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-3.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-3.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-3.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-3.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-5.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-5.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-5.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-5.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-7.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-7.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-7.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-7.jpg",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-8.webp",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-8.webp",
      "https://cv-api-omega.vercel.app/bat/pr2A1/pr2A1-8.jpg",
      "https://boogysh.github.io/cv-api/images/bat/pr2A1/pr2A1-8.jpg"
    ]
  }
};
